import { useEffect, useState } from "react";
import { fetchProducts } from "../lib/api";
import ProductCard from "./ProductCard";

const HairCareSection = ({ onQuickView, onEdit }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchProducts({ category: "Hair Care", sort: "featured" });
        if (!cancelled) setItems(data);
      } catch {
        // silent
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loading && items.length === 0) return null;

  return (
    <section
      id="hair-care"
      data-testid="hair-care-section"
      className="mx-auto max-w-[1400px] px-5 lg:px-10 pb-16 lg:pb-24"
    >
      <div className="border-t border-border/60 pt-14 lg:pt-20">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--accent))] font-medium mb-2">
              Made by Kay's
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
              Hair care
            </h2>
            <div className="text-sm text-muted-foreground mt-2 max-w-xl">
              Salon-grade products formulated by Kay's Beauty Hair to keep your
              wigs and natural hair soft, shiny, and full of life.
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
          {items.map((p) => (
            <ProductCard
              key={p.id}
              product={p}
              onQuickView={onQuickView}
              onEdit={onEdit}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HairCareSection;
